import { render, staticRenderFns } from "./SessionPopup.vue?vue&type=template&id=8b79d960&scoped=true&"
import script from "./SessionPopup.vue?vue&type=script&lang=js&"
export * from "./SessionPopup.vue?vue&type=script&lang=js&"
import style0 from "./SessionPopup.vue?vue&type=style&index=0&id=8b79d960&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b79d960",
  null
  
)

export default component.exports